import { subscribeStyles } from "@insite/content-library/Widgets/Basic/Subscribe";
import { css } from "styled-components";

subscribeStyles.emailButton = {
    typographyProps: {
        color: "#ffffff",
        size: '20px',
        weight: 700,
        lineHeight: 0,
    },
    variant: "tertiary",
    activeMode:"none",
    css: css`
    padding: 13px 24.5px;
    border-radius: 5px;
    line-height: 0;
    &:focus {
        outline-color: transparent;
    }
    &:hover {
        background: #ffffff;
    }
    &:hover span {
        color: #F7661F;
    }
    `,
};

subscribeStyles.descriptionText = {
    css: css`
        p {
            font-size: 1.25rem;
            font-weight: 500;
            margin: 0;
        }
    `
};